import NodeEvents from 'events';
import * as Inovx from '@shared';
import assign from 'object-assign';
import AssemblyLibraryConstants from '../constants/AssemblyLibraryConstants';
var EventEmitter = NodeEvents.EventEmitter;

var CHANGE_EVENT = 'AsseblyLibrary.change';
var _isAssemblyLibraryOpen: boolean = false;
var _assemblyScale: number = 1.0;
var _assemblyPosition: IVector3D = { X: 0, Y: 0, Z: 0 };
var _assemblyTemplateHasChange: boolean = false;
var _assemblyTemplateData: IAssemblyTemplate | any = null;
var _validation: IAssemblyTemplateFormErrorProps = null;

var _selectedAssemblyTemplates: IAssemblyTemplate[] = [];
var _allAssemblyTemplates: IAssemblyTemplate[] = [];
var _assemblyTemplateById: Map<string, IAssemblyTemplate> = new Map();
var _assemblyTemplates: IAssemblyTemplate[] = [];

var _assemblyLibraries: IAssemblyLibrary[] = [];
var _assemblyLibrariesWithTemplates: IAssemblyLibraryWithTemplates[] = [];
var _selectedAssemblyLibraryId: string = null;

function _initalizeValidation() {
    _setValidValidation({ Name: false, Scalable: false, Scale: false, GLB: false });
}
function _setValidValidation(data: IAssemblyTemplateFormErrorProps) {
    _validation = data;
}
function openAssemblyLibrary() {
    _isAssemblyLibraryOpen = true;
}
function closeAssemblyLibrary() {
    _isAssemblyLibraryOpen = false;
}
function setSelectedAssemblyTemplates(data: IAssemblyTemplate[]) {
    _selectedAssemblyTemplates = data ?? [];

    (_selectedAssemblyTemplates ?? []).forEach(t => {
        if (!t || !t.ID) return;
        const existing = _assemblyTemplateById.get(t.ID);
        _assemblyTemplateById.set(t.ID, existing ? { ...existing, ...t } : t);
    });

    _allAssemblyTemplates = Array.from(_assemblyTemplateById.values());
}

function setAssemblyLibraries(data: IAssemblyLibrary[]) {
    _assemblyLibraries = data;
}
function setAssemblyLibrariesWithTemplates(data: IAssemblyLibraryWithTemplates[]) {
    _assemblyLibrariesWithTemplates = data ?? [];

    // Replace global cache from authoritative payload
    const map = new Map<string, IAssemblyTemplate>();
    _assemblyLibrariesWithTemplates.forEach(lib => {
        (lib.Templates ?? []).forEach(t => {
            if (t && t.ID) map.set(t.ID, t);
        });
    });

    _assemblyTemplateById = map;
    _allAssemblyTemplates = Array.from(_assemblyTemplateById.values());
}

function setSelectedAssemblyLibraryId(id: string = null) {
    _selectedAssemblyLibraryId = id;
}
function setAssemblyTemplateData(data: IAssemblyTemplate) {
    _assemblyTemplateData = data;
    if (data?.Scale) _assemblyScale = data.Scale;
    if (data?.Origin) _assemblyPosition = data.Origin;
    _assemblyTemplateHasChange = false;
    _initalizeValidation();
}
function updateAssemblyTemplateProperty(name: string, value: any) {
    _assemblyTemplateData[name] = value;
    if (name === 'Origin') _assemblyPosition = value;
    if (name === 'Scale') _assemblyScale = value;
    _assemblyTemplateHasChange = true;
}
function setAssemblyPosition(position: IVector3D) {
    _assemblyPosition = position;
}
function setAssemblyScale(scale: number) {
    _assemblyScale = scale;
}
function setAssemblyTemplateHasChange(hasChange: boolean) {
    _assemblyTemplateHasChange = hasChange;
}
function finishedEditingAssemblyTemplate(isVisible: boolean = false) {
    _assemblyTemplateHasChange = false;
    _isAssemblyLibraryOpen = isVisible;
}
function _validate() {
    let flag = true;
    if (!_assemblyTemplateData.Name) {
        flag = false;
        _validation.Name = true;
    } else {
        _validation.Name = false;
    }
    if (!_assemblyTemplateData.Scale || _assemblyTemplateData.Scale === null || _assemblyTemplateData.Scale === undefined || _assemblyTemplateData.Scale == 0) {
        flag = false;
        _validation.Scale = true;
    } else {
        _validation.Scale = false;
    }
    if (!_assemblyTemplateData.GraphicsFileUrl && !_assemblyTemplateData.GraphicsFileData) {
        flag = false;
        _validation.GLB = true;
    } else {
        _validation.GLB = false;
    }
    return flag;
}

var AssemblyLibraryStore: IAssemblyLibraryStore = assign({}, EventEmitter.prototype, {
    getAssemblyLibraryVisible: function () {
        return _isAssemblyLibraryOpen;
    },
    getValidation() {
        return _validation;
    },
    getIsValidObject() {
        return _validate();
    },
    getAssemblyTemplateData: function () {
        return _assemblyTemplateData;
    },
    getAssemblyPosition: function () {
        return _assemblyPosition;
    },
    getAssemblyScale: function () {
        return _assemblyScale;
    },
    getHasAssemblyTemplateChange: function () {
        return _assemblyTemplateHasChange;
    },
    getAssemblyTemplates: function () {
        return _selectedAssemblyTemplates;
    },
    getAllAssemblyTemplates: function () {
        return _allAssemblyTemplates;
    },
    getAssemblyTemplateById: function (id: string) {
        return _assemblyTemplateById.get(id) ?? null;
    },
    getAssemblyLibraries: function () {
        return _assemblyLibraries;
    },
    getAssemblyLibrariesWithTemplates: function () {
        return _assemblyLibrariesWithTemplates;
    },
    getSelectedAssemblyLibraryId: function () {
        return _selectedAssemblyLibraryId;
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback: any) {
        this.removeListener(CHANGE_EVENT, callback);
    },
});

Inovx.Shared.Flux.AppDispatcher.register(function (payload: any) {
    switch (payload.actionType) {
        case AssemblyLibraryConstants.OPEN_ASSEMBLY_LIBRARY:
            openAssemblyLibrary();
            break;
        case AssemblyLibraryConstants.CLOSE_ASSEMBLY_LIBRARY:
            closeAssemblyLibrary();
            break;
        case AssemblyLibraryConstants.ASSEMBLY_TEMPLATE_SET_DATA:
            setAssemblyTemplateData(payload.data);
            break;
        case AssemblyLibraryConstants.ASSEMBLY_TEMPLATE_UPDATE_EDIT:
            updateAssemblyTemplateProperty(payload.key, payload.value);
            break;
        case AssemblyLibraryConstants.SET_ASSEMBLY_POSITION:
            setAssemblyPosition(payload.data);
            break;
        case AssemblyLibraryConstants.SET_ASSEMBLY_SCALE:
            setAssemblyScale(payload.data);
            break;
        case AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_HAS_CHANGE:
            setAssemblyTemplateHasChange(payload.data);
            break;
        case AssemblyLibraryConstants.ASSEMBLY_LIBRARY_FINISH_EDIT:
            finishedEditingAssemblyTemplate(payload.isVisible);
            break;
        case AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATES:
            setSelectedAssemblyTemplates(payload.data);
            break;
        case AssemblyLibraryConstants.ASSEMBLY_LIBRARIES:
            setAssemblyLibraries(payload.data);
            break;
        case AssemblyLibraryConstants.ASSEMBLY_LIBRARIES_WITH_TEMPLATES:
            setAssemblyLibrariesWithTemplates(payload.data);
            break;
        case AssemblyLibraryConstants.SET_SELECTED_ASSEMBLY_LIBRARY_ID:
            setSelectedAssemblyLibraryId(payload.data);
            break;
        case AssemblyLibraryConstants.ASSEMBLY_TEMPLATE_INVALID_ADD:
            break;
        default:
            return true;
    }

    AssemblyLibraryStore.emitChange();
    return true;
});

export default AssemblyLibraryStore;